import { render, staticRenderFns } from "./PartnersList.vue?vue&type=template&id=09688396&scoped=true&"
import script from "./PartnersList.vue?vue&type=script&lang=js&"
export * from "./PartnersList.vue?vue&type=script&lang=js&"
import style0 from "./PartnersList.vue?vue&type=style&index=0&id=09688396&lang=scss&scoped=true&"
import style1 from "./PartnersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09688396",
  null
  
)

export default component.exports